var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"error-wrapper"},[_c('div',{staticClass:"error-message"},[_c('h2',[_vm._v("Whoops")]),_c('p',[_vm._v("Something went wrong. The page you are trying to find is no longer here.")]),_c('router-link',{attrs:{"to":{path: '/' }}},[_vm._v("To start page ›")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }